import { getStandardControlSemanticColorsWithTheme } from "@1js/acui-common";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type {
  IContextualMenuItem,
  IContextualMenuListProps,
  IRenderFunction,
  Theme,
} from "@fluentui/react";
import * as React from "react";
import { getFlexMenuClassNames } from "./AppFlexMenu.classNames";

export interface AppFlexMenuProps {
  theme: Theme;
  headerProps?: IContextualMenuItem;
  footerProps: IContextualMenuItem;
  containerRef: React.LegacyRef<HTMLDivElement>;
  menuListProps: IContextualMenuListProps;
  defaultRender: IRenderFunction<IContextualMenuListProps>;
  expandMaxHeight: boolean;
}

export const AppFlexMenu: React.FC<AppFlexMenuProps> = (props) => {
  const {
    headerProps,
    footerProps,
    menuListProps,
    defaultRender,
    containerRef,
    theme,
    expandMaxHeight,
  } = props;
  const header =
    headerProps &&
    menuListProps.defaultMenuItemRenderer({
      ...headerProps,
      index: -1,
      focusableElementIndex: -1,
      totalItemCount: 1,
      hasCheckmarks: false,
      hasIcons: false,
    });
  const footer = menuListProps.defaultMenuItemRenderer({
    ...footerProps,
    index: -1,
    focusableElementIndex: -1,
    totalItemCount: 1,
    hasCheckmarks: false,
    hasIcons: true,
  });

  const classNames = getFlexMenuClassNames(expandMaxHeight);
  const colors = getStandardControlSemanticColorsWithTheme(theme);
  const style = {
    "--border-color": colors.borderColor,
    "--scroll-background": "transparent",
  } as React.CSSProperties;
  return (
    <div className={classNames.root} style={style}>
      {header && <div className={classNames.header}>{header}</div>}
      <div className={classNames.container} ref={containerRef}>
        {defaultRender(menuListProps)}
      </div>
      <div className={classNames.footer}>{footer}</div>
    </div>
  );
};
